/* eslint-env browser */
var setFocus = function setFocus() {
  var rootEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  setTimeout(function () {
    var el = rootEl.querySelector('h1,h2,h3');
    if (el) el.focus();
  }, 50);
};

export default setFocus;